"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var next_components_1 = require("@dotdev/next-components");
var ProductCustomize = /** @class */ (function (_super) {
    __extends(ProductCustomize, _super);
    function ProductCustomize(props) {
        var _this = _super.call(this, props) || this;
        _this.buildPlayersOptions = function () {
            var product = _this.props.product;
            var players = product.metafields && product.metafields.featuredPlayers;
            return players
                ? players.map(function (player) { return (React.createElement("option", { key: player.number, value: "" + player.number },
                    "\u00A0\u00A0",
                    player.number,
                    "\u00A0\u00A0\u00A0",
                    player.name)); })
                : [];
        };
        _this.handleSelectChange = function (e) {
            _this.setState({
                playerNumber: e.target.value,
                customizedNumber: ""
            }, function () {
                _this.props.handleCustomizedNumber(_this.state.playerNumber);
            });
        };
        _this.handleInputChange = function (e) {
            var value = e.target.value;
            _this.setState({
                customizedNumber: value,
                playerNumber: ""
            }, function () {
                _this.props.handleCustomizedNumber(_this.state.customizedNumber);
            });
        };
        _this.handleAddToGuernsey = function () {
            _this.setState({
                added: true
            });
        };
        _this.state = {
            customizedNumber: "",
            playerNumber: "",
            added: false
        };
        return _this;
    }
    ProductCustomize.prototype.render = function () {
        var priceOneKey = this.props.handle === 'jumper' ? this.props.section.product.settings.jumper_one_num_price : this.props.section.product.settings.one_num_price;
        var priceTwoKey = this.props.handle === 'jumper' ? this.props.section.product.settings.jumper_two_num_price : this.props.section.product.settings.two_num_price;
        var oneNumPrice = next_components_1.ShopifyNext.Utils.formatMoney((Number.parseInt(priceOneKey)) * 100, this.props.moneyFormat);
        var twoNumPrice = next_components_1.ShopifyNext.Utils.formatMoney((Number.parseInt(priceTwoKey)) * 100, this.props.moneyFormat);
        return (React.createElement("div", { className: "flex flex-col items-center justify-around text-navy-dark bg-arctic " + (this.props.isCustomizeFormActive ? "shadow-active" : "shadow-inactive") + " mb-2-4 p-1-3 rounded" + (this.props.className ? " " + this.props.className : "") },
            React.createElement("div", { className: "flex flex-row w-full justify-between cursor-pointer", onClick: this.props.toggleCustomizeForm },
                React.createElement(Snippets.Svg, { name: "guernsey", width: 24, height: 24, className: "" }),
                React.createElement("div", { className: "flex flex-col w-full pl-2-1" },
                    React.createElement("span", { className: "text-base font-semibold" },
                        "Customize your ",
                        React.createElement("span", { className: "capitalize" }, this.props.handle)),
                    React.createElement("span", { className: "text-xs text-grey-dark" },
                        "Starting from",
                        oneNumPrice)),
                React.createElement(Snippets.Svg, { name: "add", width: 32, height: 32 })),
            React.createElement("div", { className: (this.props.isCustomizeFormActive ? "" : "hidden") + " w-full" },
                React.createElement("div", { className: "flex flex-col w-full px-1-2" },
                    React.createElement("div", { className: "flex flex-col mt-2-4 mb-1-6" },
                        React.createElement("span", { className: "uppercase text-xs font-semibold mb-0-8 tracking-wideless" }, "Players"),
                        React.createElement("div", { className: "relative mb-1-7" },
                            React.createElement("select", { onChange: this.handleSelectChange, value: this.state.playerNumber, disabled: this.state.added, className: "block rounded relative w-full h-full px-1-6 text-base bg-arctic text-dark-navy border border-secondary-blue-grey transition-fast outline-none appearance-none cursor-pointer focus:outline-none focus:shadow-none py-1-4" },
                                React.createElement("option", { value: "" }, "\u00A0\u00A0Select a player"),
                                this.buildPlayersOptions()),
                            React.createElement("span", { className: "pointer-events-none absolute pin-y pin-r flex justify-center text-grey-mid-midnight", style: { right: "12px" } },
                                React.createElement(Snippets.Svg, { name: "chevron-down", width: 12 })))),
                    React.createElement("div", { className: "flex flex-row mb-2-4" },
                        React.createElement("hr", { className: "w-full border border-secondary-blue-grey" }),
                        React.createElement("span", { className: "px-0-8 text-grey-dark" }, "Or"),
                        React.createElement("hr", { className: "w-full border border-secondary-blue-grey" })),
                    React.createElement("div", { className: "flex flex-col mb-2-4" },
                        React.createElement("div", { className: "flex flex-row mb-1-6" },
                            React.createElement("div", { className: "w-full flex flex-col" },
                                React.createElement("span", { className: "uppercase text-xs font-semibold mb-0-8 tracking-wideless" }, "Number"),
                                React.createElement("input", { className: "pl-1-6 h-4-8 border border-secondary-blue-grey rounded outline-none", type: "text", value: this.state.customizedNumber, onChange: this.handleInputChange, maxLength: 2, disabled: this.state.added }))),
                        React.createElement("div", { className: "flex flex-col" },
                            React.createElement("div", null,
                                React.createElement("span", { className: "text-grey-dark text-xs" }, "Numbers:\u00A0"),
                                React.createElement("span", { className: "text-navy-dark text-sm font-semibold" },
                                    "One number = ",
                                    oneNumPrice,
                                    " Two numbers = ",
                                    twoNumPrice)))),
                    React.createElement("button", { type: "button", className: "border rounded py-1-3 text-md font-bold text-center w-full mb-1-2 " + (this.state.added ? "text-grey-dark border-grey-dark pointer-event-none" : "text-midnight border-navy cursor-pointer"), onClick: this.handleAddToGuernsey, disabled: this.state.added }, this.state.added ? "Customized Number Added" :
                        React.createElement("span", null,
                            "Add to ",
                            React.createElement("span", { className: "capitalize" }, this.props.handle)))))));
    };
    ProductCustomize.contextType = next_components_1.ShopifyNext.Context;
    return ProductCustomize;
}(React.PureComponent));
exports.ProductCustomize = ProductCustomize;
